export default __webpack_public_path__ + "static/salgado-0051aede649b25320ee73c51ac486832.png";